import { PublicInfoLayout } from "./PublicInfoLayout";

const Section = ({ title, children }) => (
  <section>
    <h2 className="font-heading text-2xl font-semibold tracking-tight text-white">
      {title}
    </h2>
    <div className="mt-3 space-y-3 text-zinc-400">{children}</div>
  </section>
);

export default function Terms() {
  return (
    <PublicInfoLayout eyebrow="Terms of Service" title="Course access terms">
      <p className="text-zinc-400">
        By using Kirubeezy Studios, you agree to
        use the course and account features responsibly and only for your own
        learning.
      </p>

      <Section title="Course license">
        <p>
          Your subscription or purchase gives you personal, non-transferable
          access to the course materials. You may not resell, redistribute,
          publish, record, or share restricted videos, downloads, or dashboard
          access.
        </p>
      </Section>

      <Section title="Accounts and payments">
        <p>
          You are responsible for keeping your account secure. Course access may
          depend on successful payment, subscription status, and identity
          verification through the services connected to this site.
        </p>
      </Section>

      <Section title="Acceptable use">
        <p>
          Do not attempt to bypass access controls, scrape protected content,
          interfere with the platform, or use the site in a way that harms other
          users, the course owner, or connected service providers.
        </p>
      </Section>

      <Section title="Support and changes">
        <p>
          We may update course content, platform features, pricing, or these
          terms over time. For account or billing questions, use the contact
          page so the request can be routed correctly.
        </p>
      </Section>
    </PublicInfoLayout>
  );
}
